import { API, API_GET } from "../../config";

export const GetAnalytics = () => {
  return API_GET(API.UserAnaytics);
};
